import { CloseCircleFilled, SearchOutlined } from "@ant-design/icons";
import { theme } from "antd";
import debounce from "lodash/debounce";
import { useState } from "react";
import styled from "styled-components";
import { RowComponent } from "./row.component";

const StyledInput = styled.input`
  background-color: ${({ colorBgContainer }) => colorBgContainer};
  color: ${({ colorText }) => colorText};
  border-radius: 0px;
  border: none;
  padding: 8px;
  flex-grow: 1;
  outline: none;
`;

const SearchIcon = styled.span`
  color: gray;
  padding: 8px;
`;

const ClearIcon = styled.span`
  color: gray;
  cursor: pointer;
  padding: 8px;
`;

export const SearchComponent = ({
  placeholder = "Buscar",
  onSearch = (value) => console.log(value),
  onClear = () => console.log("clear"),
}) => {
  const [value, setValue] = useState("");
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken();

  const debouncedSearch = debounce((value) => onSearch(value), 500);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSearch(newValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && value.length > 3) {
      onSearch(value);
    }
  };

  return (
    <RowComponent
      style={{
        borderRadius: 12,
        backgroundColor: colorBgContainer,
        overflow: "hidden",
      }}
    >
      <SearchIcon>
        <SearchOutlined />
      </SearchIcon>
      <StyledInput
        colorText={colorText}
        colorBgContainer={colorBgContainer}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
      />
      {value && (
        <ClearIcon
          onClick={() => {
            setValue("");
            onClear();
          }}
        >
          <CloseCircleFilled />
        </ClearIcon>
      )}
    </RowComponent>
  );
};
